import { render, staticRenderFns } from "./NovoReajusteEHistorico.vue?vue&type=template&id=7618f824&scoped=true"
import script from "./NovoReajusteEHistorico.vue?vue&type=script&lang=js"
export * from "./NovoReajusteEHistorico.vue?vue&type=script&lang=js"
import style0 from "./NovoReajusteEHistorico.vue?vue&type=style&index=0&id=7618f824&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7618f824",
  null
  
)

export default component.exports